module.exports = __webpack_public_path__ + "static/img/icon-en-7.12f1c50c.png";